import apiClient from './client';
import { entriesApiUrl } from '../utils/runtime';

export async function loadEntries() {
  const data = await apiClient.get(entriesApiUrl);
  if (data && Array.isArray(data.entries)) {
    return data.entries;
  }
  if (Array.isArray(data)) {
    return data;
  }
  return [];
}

export async function createEntry(payload) {
  return apiClient.post(entriesApiUrl, payload);
}

export async function updateEntry(id, fields) {
  return apiClient.patch(`${entriesApiUrl}/${id}`, fields);
}

export async function deleteEntry(id) {
  return apiClient.delete(`${entriesApiUrl}/${id}`);
}
